import qs from 'qs';
import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { AccessBundle, LogInPayload } from '../store/modules/auth/types';

class AuthService {
  private route = apis.oauth;

  private clientId = process.env.REACT_APP_API_CLIENT_ID;

  private clientSecret = process.env.REACT_APP_API_CLIENT_SECRET;

  private accessScope = '*';

  constructor(private api: ApiService) {}

  login = ({ email: username, password }: LogInPayload) => this.api.post<AccessBundle>(
    this.route.token,
    qs.stringify({
      username,
      password,
      grant_type: 'password',
      client_id: this.clientId,
      client_secret: this.clientSecret,
      scope: this.accessScope,
    }),
  );

  refresh = (token: string) => this.api.post<AccessBundle>(
    this.route.token,
    qs.stringify({
      grant_type: 'refresh_token',
      client_id: this.clientId,
      client_secret: this.clientSecret,
      refresh_token: token,
      // duration: 'P1S', // for testing
    }),
  );

  unauthorized = (refreshToken: string) => this.api.post<AccessBundle>(
    this.route.token,
    qs.stringify({
      client_id: this.clientId,
      client_secret: this.clientSecret,
      refresh_token: refreshToken,
      scope: '*',
      grant_type: 'refresh_token',
      // duration: 'P1S', // for testing
    }),
  );
}

export default new AuthService(apiService);
